export const filterMaterialsByAttributes = (
  materials,
  selectedAttributeValues
) => {
  const filtered = materials.filter((material) => {
    let isMatch = false;
    isMatch = Object.entries(selectedAttributeValues).every(
      ([attributeId, values]) => {
        const attribute = material.attributes.find(
          (attr) => attr.attributeId === attributeId
        );
        return attribute && values.includes(attribute.value);
      }
    );
    return isMatch;
  });
  return filtered;
};

export const filterMaterialsByCategory = (materials, selectedCategory) => {
  return materials.filter((material) => {
    return material.category.categoryId === selectedCategory.categoryId;
  });
};

export const filterMaterialsBySearch = (materials, debouncedSearch) => {
  return materials.filter((material) => {
    return (
      material.category.itemCode
        ?.toLowerCase()
        .includes(debouncedSearch.toLowerCase()) ||
      material.category.itemDescription
        ?.toLowerCase()
        .includes(debouncedSearch.toLowerCase())
    );
  });
};

export const filterInactiveAttributes = (materials) => {
  return materials.map((item) => ({
    ...item,
    attributes: item.attributes.filter(
      (attr) => attr.categoryAttributeIsActive
    ),
  }));
};

export const sortCategoryAttributes = (category) => {
  const sortedCategory = { ...category };
  // sort attributes to push any without options to the bottom (disabled), preserving attribute.displayOrder first
  sortedCategory.attributes?.sort((a, b) => {
    if (a.values.length === 0) {
      return 1;
    }
    if (b.values.length === 0) {
      return -1;
    }
    return a.attributeDisplayOrder - b.attributeDisplayOrder;
  });
  return sortedCategory;
};

export const getSelectedAttributeValues = (
  attributeId,
  attributeValue,
  selectedAttributeValues,
  setSelectedAttributeValues
) => {
  const selectedOptions = selectedAttributeValues?.[attributeId] ?? [];
  const optionIndex = selectedOptions.indexOf(attributeValue);

  if (optionIndex >= 0) {
    selectedOptions.splice(optionIndex, 1);
  } else {
    selectedOptions.push(attributeValue);
  }

  setSelectedAttributeValues((prev) => {
    // if all options are deselected, remove the attribute from the object
    if (selectedOptions.length === 0) {
      const updated = { ...prev };
      delete updated[attributeId];
      return updated;
    }
    return {
      ...prev,
      [attributeId]: selectedOptions,
    };
  });
};
